<div class="min-h-screen flex flex-col lg:flex-row">
  <div class="flex flex-col place-content-center text-center p-8 lg:w-1/2">
    <p class="text-base font-semibold text-primary">404</p>
    <h1 class="mt-4 text-5xl sm:text-7xl font-semibold">{{ 'notFound.title' | translate }}</h1>
    <p class="mt-6 text-lg font-medium text-pretty text-muted-foreground sm:text-xl/8">{{ 'notFound.subtitle' | translate }}</p>

    <div class="mt-8 flex gap-4 flex-col justify-center sm:flex-row">
      @if (navigationService.getPreviousUrl() !== undefined) {
        <app-btn [linkUrl]="navigationService.getPreviousUrl()" icon="fas fa-arrow-left" [label]="'notFound.back' | translate"></app-btn>
      }
      <app-btn linkUrl="/" [label]="'common.home' | translate"></app-btn>
    </div>
  </div>

  <div class="hidden lg:block lg:w-1/2 relative">
    <div class="w-full h-full aspect-[4/3]">
      <img 
        [src]="'https://cataas.com/cat/kitten?random=' + randomSuffix" 
        [alt]="'notFound.altImg' | translate"
        class="w-full h-full object-cover"
      />
    </div>
  </div>
</div>
